import MyTablePagination from "@components/pagination/TablePagination";
import { TableHeadCustom, TableNoData } from "@components/table";
import {
  Button,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useCommonStyles } from "@pages/ManualDocumentV2/hooks/useCommonStyles";
import { fDateTime } from "@utils/formatTime";
import {
  IDocumentsTable,
  IItemsEntity,
} from "../../../../@types/manualDocument/documentSeriesTypes";

export const DocumentsTable = ({
  isLoading,
  documentSeriesData,
  isWriteDisabled,
  setDeleteId,
  TABLE_HEAD,
  translate,
}: IDocumentsTable) => {
  const { table, tableContainer, tableRow } = useCommonStyles();

  const filteredTableHead = TABLE_HEAD.filter(h => h.id !== "actions");

  return (
    <TableContainer sx={tableContainer}>
      <Table size="small" sx={table}>
        <TableHeadCustom headLabel={filteredTableHead} />
        <TableBody>
          {isLoading ? (
            [...Array(5)].map((_, i) => (
              <TableRow key={i}>
                <TableCell>
                  <Skeleton animation="wave" width="80%" height={24} />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" width="60%" height={24} />
                </TableCell>
                <TableCell>
                  <Skeleton animation="wave" width="70%" height={24} />
                </TableCell>
              </TableRow>
            ))
          ) : documentSeriesData.length > 0 ? (
            documentSeriesData.map((item: IItemsEntity) => (
              <TableRow
                key={item.id}
                hover
                sx={{ backgroundColor: "inherit", ...tableRow }}
              >
                <TableCell>{item.series}</TableCell>
                <TableCell>{item.initialSequenceNumber}</TableCell>
                <TableCell>
                  {item.updatedOn || item.createdOn
                    ? fDateTime((item.updatedOn || item.createdOn) as string)
                    : "-"}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={filteredTableHead.length} align="center">
                {translate("no_data_found")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
